/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const resolveParticipantsBodyInvitationIdsDefault = [];
export const resolveParticipantsBodyInvitationIdsMax = 100;

export const resolveParticipantsBodyReachUserIdsDefault = [];
export const resolveParticipantsBodyReachUserIdsMax = 100;

export const ResolveParticipantsBody = zod.object({
  invitationIds: zod
    .array(zod.uuid().describe('UUID v4 identifier'))
    .max(resolveParticipantsBodyInvitationIdsMax)
    .default(resolveParticipantsBodyInvitationIdsDefault)
    .describe("Core invitation uuids (from the roster's invitations array) to describe"),
  reachThreadId: zod
    .uuid()
    .optional()
    .describe(
      "The thread being shown. When it is a group's own chat, each resolved actor carries groupRole, for a caller who is in that group",
    ),
  reachUserIds: zod
    .array(zod.uuid())
    .max(resolveParticipantsBodyReachUserIdsMax)
    .default(resolveParticipantsBodyReachUserIdsDefault)
    .describe('Reach user ids from a thread roster to name'),
});

export type ResolveParticipantsBody = zod.input<typeof ResolveParticipantsBody>;
export type ResolveParticipantsBodyOutput = zod.output<typeof ResolveParticipantsBody>;
